<template>
  <div class="premium-message-send-confirm">
    <div class="prev" @click="prev">
      <i class="bi bi-chevron-left"></i>
      <div class="title">
        内容を確認する
      </div>
    </div>
    <div class="message">
      {{ message }}
    </div>
    <div class="actions">
      <button type="button" class="edit-button" @click="prev">
        修正する
      </button>
      <button type="button" class="send-button" @click="send">
        送信する
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userIdTo: {
      type: Number,
      default: 0,
    },
    message: {
      type: String,
      default: '',
    },
    eventGroupId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    prev() {
      this.$emit('prev')
    },
    async send() {
      try {
        const payload = {
          user_id_to: this.userIdTo,
          source_screen: 'user_profile',
          message: this.message
        }
        if (this.eventGroupId) {
          payload.event_group_id = this.eventGroupId
        }
        await axios.post('/api/matching/premium-message-like/set', payload)

        this.$emit('send')
      } catch (error) {
        if (error.response) {
          const { status, data } = error.response

          if (status === 401) {
            window.location.href = '/auth?logout=true'
            return
          }

          if (status === 422) {
            const errors = data?.errors || {}
            const firstError = Object.values(errors)[0]
            const message = Array.isArray(firstError) && firstError.length > 0
              ? firstError[0]
              : data?.message || '入力内容に誤りがあります。'

            this.$showErrorToast(message)
            return
          }

          if (status === 409) {
            this.$showErrorToast(data?.message || 'プレミアムメッセージの送信に失敗しました。')
            return
          }

          this.$showErrorToast('プレミアムメッセージの送信に失敗しました。')
        } else {
          this.$showErrorToast('通信に失敗しました。時間を置いて再度お試しください。')
        }
      }
    },
  }
}
</script>

<style scoped>
.premium-message-send-confirm {
  position: fixed;
  top: 0;
  left: 50%;
  width: 100%;
  max-width: 540px;
  height: 100%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  background: #fff;
}

.prev {
  position: relative;
  padding: 16px 12px;
  text-align: center;
  border-bottom: 1px solid #efeef0;
}

.prev .bi-chevron-left {
  position: absolute;
  left: 12px;
  cursor: pointer;
  -webkit-text-stroke: 1px;
}

.prev .title {
  font-size: 16px;
  font-weight: 700;
}

.message {
  flex: 1;
  padding: 16px;
  padding-bottom: 120px;
  font-size: 14px;
  overflow-y: auto;
  line-height: 1.5;
  white-space: pre-line;
}

.actions {
  position: fixed;
  left: 50%;
  bottom: 0;
  width: 100%;
  max-width: 540px;
  transform: translateX(-50%);
  padding: 16px;
  display: flex;
  gap: 12px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 48%);
}

.edit-button,
.send-button {
  padding: 16px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 16px;
  border: none;
}

.edit-button {
  flex: 3;
  color: #5538ee;
  background: #fff;
  border: 1px solid #dadadd;
}

.send-button {
  flex: 7;
  color: #fff;
  background: #5538ee;
}
</style>
